import Footer from '@components/book-trial-for-uae/footer'
import WhyCodingal from '@components/book-trial-for-uae/why-codingal'
import Benefits from '@components/landing-page/geo-landing-page/benefits'
import FirstFold from '@components/landing-page/geo-landing-page/first-fold'
import Partners from '@components/landing-page/geo-landing-page/partners'
import Testimonials from '@components/landing-page/geo-landing-page/testimonials'
import Testimonial from '@components/summer-camp/testimonial'
import { TARGATED_REGIONS } from '@lib/constants/geo-lp'
import { partnerLandingPageSeo } from '@lib/seo'
import { UnionizeObjValues } from '@lib/types/common'
import { NextSeo } from 'next-seo'
import Script from 'next/script'

export type PartnerProps = {
  slug: string
  logo: string
  countryCode: string
  region: UnionizeObjValues<typeof TARGATED_REGIONS>
  logoImageProperties: {
    width?: number
    height?: number
    alt?: string
  }
  isArabCountry?: boolean
  customHeading?: string
  customSubHeading?: string
}

const Partner = ({
  countryCode,
  slug,
  logo,
  region,
  logoImageProperties,
  isArabCountry,
  customHeading,
  customSubHeading,
}: PartnerProps) => {
  return (
    <>
      <NextSeo {...partnerLandingPageSeo(slug)} />
      <FirstFold
        countryCode={countryCode}
        shouldHaveFormShadow={true}
        partnerLogo={logo}
        logoImageProperties={logoImageProperties}
        customHeading={customHeading}
        customSubHeading={customSubHeading}
      />
      <Partners />
      {slug === 'the-robotics-club-pakistan' && (
        <div className="pt-20 pb-8 text-grey">
          <h2 className="text-center text-xl md:text-2xl font-700 mb-8">
            Exciting coding courses for your child in partnership with Codingal
            & The Robotics Club
          </h2>
          <div
            id="codingal-courses"
            data-currency="PKR"
            data-cta-link="/the-robotics-club-pakistan/?utm_source=trcp"
            data-courses="all"
            data-ethnicity="Pakistani"
          ></div>
          <Script
            async
            defer
            crossOrigin="anonymous"
            src="https://websdk.codingal.com/courses/main.min.js"
          ></Script>
        </div>
      )}
      <Benefits region={region} />
      {isArabCountry ? (
        <Testimonial pageCta="Book Free Lesson" isArabCountry={true} />
      ) : (
        <Testimonials />
      )}
      <WhyCodingal />
      <Footer />
    </>
  )
}

export default Partner
